import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('buttons-group', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('buttons-group');

      return new ViewModel(params, element);
    },
  },
  template: html,
});